module.exports = __webpack_public_path__ + "img/asset1.488e38ea.svg";